// extracted by mini-css-extract-plugin
export default {"layout":"AppLayout_layout__RmhlF","content":"AppLayout_content__TLVuQ"};